export interface IUpdateSaleChannel {
  name?: string;
  description?: string;
  platformType: string;
  favIcon?: string | null;
  logo?: string | null;
}
